module.exports = __webpack_public_path__ + "img/terImg3.5f388659.png";